export interface TradeContractFormatGroup {
  id: string;
  name: string;
  description: string;
  terminalId: string;
}

export interface TradeContractFormatGroupState {
  groups: TradeContractFormatGroup[];
}

/** 取引契約フォーマットグループに属する事が可能な取引契約フォーマットの最大数 */
export const MAX_TRADE_CONTRACT_FORMAT_COUNT = 24;
